import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import type { InstallationMonorepo } from '~/services/installation-monorepo/installation-monorepo.types';

import installationMonorepoApi from '~/services/installation-monorepo/installation-monorepo';

import { installationBypassQueryKey } from './useInstallationBypass';

type RemoveParams = InstallationMonorepo.RemoveParams;

export default function useDeleteInstallationBypass() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RemoveParams) => installationMonorepoApi.remove(params),
    onError: (error: any) => {
      const status = error?.response?.status;
      const apiMessage = error?.response?.data?.message || error?.response?.data?.detail;

      const errorMessages = {
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || apiMessage
        || 'Erro inesperado ao remover bypass de instalação.';

      toast.error(errorMessage);
    },
    onSuccess: (data, variables) => {
      toast.success(data.message || 'Bypass de instalação removido com sucesso!');
      queryClient.invalidateQueries({
        queryKey: installationBypassQueryKey(variables.partnerId),
      });
    },
    retry: false,
  });
}
